/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  function parseLeadingNumber(str) {
    var match = (str || '').trim().match(/^(\d+)/);
    return match ? parseInt(match[1], 10) : 0;
  }

  function updateLegendText(field) {
    var checked = field.querySelector('input[type="radio"]:checked');
    var legendValue = field.querySelector('[data-option-value]');
    if (checked && legendValue) {
      legendValue.textContent = checked.value;
    }
  }

  function setFieldVisibility(field, stoneCount) {
    var min = parseInt(field.getAttribute('data-min-stones'), 10);
    var inputs = field.querySelectorAll('input[type="radio"]');
    var shouldShow = stoneCount >= min;

    if (shouldShow) {
      field.hidden = false;
      inputs.forEach(function (input) {
        input.disabled = false;
      });

      if (!field.querySelector('input[type="radio"]:checked') && inputs.length) {
        inputs[0].checked = true;
      }

      updateLegendText(field);
    } else {
      field.hidden = true;
      inputs.forEach(function (input) {
        input.disabled = true;
      });
    }
  }

  function initBirthstoneExtraWrapper(wrapper) {
    if (wrapper.dataset.birthstoneExtraInit) return;
    wrapper.dataset.birthstoneExtraInit = 'true';

    var position = parseInt(wrapper.getAttribute('data-option-position'), 10) - 1;
    var fields = wrapper.querySelectorAll('[data-birthstone-extra-field]');

    fields.forEach(function (field) {
      updateLegendText(field);

      field.addEventListener('change', function (e) {
        if (e.target.matches('input[type="radio"]')) {
          updateLegendText(field);
        }
      });
    });

    document.addEventListener('theme:variant:change', function (evt) {
      var variant = evt.detail && evt.detail.variant;
      if (!variant || !evt.target.contains(wrapper)) return;

      var stoneCount = parseLeadingNumber(variant.options[position]);
      fields.forEach(function (field) {
        setFieldVisibility(field, stoneCount);
      });
    });
  }

  function initAllBirthstoneExtraWrappers() {
    document.querySelectorAll('[data-birthstone-extra-wrapper]').forEach(initBirthstoneExtraWrapper);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllBirthstoneExtraWrappers);
  } else {
    initAllBirthstoneExtraWrappers();
  }

  document.addEventListener('shopify:section:load', initAllBirthstoneExtraWrappers);

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
